module.exports = __webpack_public_path__ + "b47538adcca88decd58dba631ebadef7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/DZ.svg
// module id = Fmlp
// module chunks = 0